import { values, is } from 'ramda'

import * as types from './types'


const allIdentifierTypes = values(types).filter(is(String))

export default allIdentifierTypes
